import { OnboardingSubscriptionOrderState } from '@houzy/schemas/partner-cockpit/onboarding';

// Stripe hands the craftsman back before its webhook has necessarily reached us, so a successful return can land on
// an order that still reads as awaiting payment.
export const WEBHOOK_POLL_INTERVAL_MS = 3_000;
export const WEBHOOK_POLL_WINDOW_MS = 15_000;

type WebhookPollInput = {
    state: OnboardingSubscriptionOrderState | undefined;
    payment: 'success' | 'cancelled' | undefined;
    pollUntil: number;
    now: number;
};

export function webhookPollInterval({ state, payment, pollUntil, now }: WebhookPollInput): number | false {
    if (payment !== 'success' || state !== OnboardingSubscriptionOrderState.AwaitingPaymentDetails) {
        return false;
    }
    return now > pollUntil ? false : WEBHOOK_POLL_INTERVAL_MS;
}
